<template>
  <label
    class="option-card flex items-start gap-3 p-4 rounded-xl transition-colors"
    :class="cardClass"
    :style="{ backgroundColor }"
  >
    <input
      type="checkbox"
      class="sr-only"
      :checked="checked"
      :disabled="disabled"
      @change="$emit('toggle', $event.target.checked)"
    />

    <span
      class="flex-shrink-0 w-5 h-5 rounded border-2 flex items-center justify-center mt-0.5"
      :class="iconClass"
    >
      <svg
        v-if="effectiveChecked"
        class="w-3 h-3 text-white"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="3"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </span>

    <div class="min-w-0">
      <span class="flex flex-wrap items-center gap-2">
        <span class="text-sm font-bold" :class="textDimClass">
          {{ title }}
        </span>
        <slot name="title-extra" />
      </span>
      <span
        class="block text-sm mt-1 leading-snug"
        :class="textDimClass"
      >
        {{ description }}
      </span>
    </div>
  </label>
</template>

<script>
export default {
  name: "OptionCardCheckbox",
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    /**
     * When true, show the selected style + check icon even if the checkbox
     * itself is disabled (used for "Auto" steps, which are read-only).
     */
    showSelectedWhenDisabled: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: "#FBFBFB",
    },
  },
  computed: {
    effectiveChecked() {
      if (this.showSelectedWhenDisabled) return this.checked;
      return this.checked && !this.disabled;
    },
    textDimClass() {
      return this.disabled && !this.effectiveChecked ? "text-gray-400" : "";
    },
    cardClass() {
      if (this.effectiveChecked) {
        return this.disabled
          ? "option-card--selected border-transparent cursor-default"
          : "option-card--selected border-transparent cursor-pointer";
      }
      return this.disabled ? "opacity-60 cursor-not-allowed" : "opacity-60 cursor-pointer";
    },
    iconClass() {
      return this.effectiveChecked
        ? "option-check--on border-0"
        : "border-gray-300 bg-white";
    },
  },
};
</script>

<style>
.option-card--selected {
  background: #f9fafb;
}

.option-check--on {
  background: var(--org-onboarding-accent, #F15A29);
}
</style>

